import { render } from "./Settings-NotificationDetails.vue?vue&type=template&id=a2f13a82&scoped=true"
import script from "./Settings-NotificationDetails.vue?vue&type=script&lang=js"
export * from "./Settings-NotificationDetails.vue?vue&type=script&lang=js"

import "./Settings-NotificationDetails.vue?vue&type=style&index=0&id=a2f13a82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f13a82"]])

export default __exports__